export default {
    edit: 'Modifier',
    location: 'Emplacement + C&G',
    filter: 'Filtrer',
};
